function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useContext } from 'react';
import styles from './SnackBarTitle.module.scss';
import { SnackBarContext } from '../SnackBar/SnackBar';
import I18n from '../../I18n/I18n/I18n';
import cs from 'classnames';
export default function SnackBarTitle(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle;
  var size = useContext(SnackBarContext);
  return /*#__PURE__*/React.createElement("div", {
    className: cs(styles.container, styles["container--".concat(size)])
  }, title && /*#__PURE__*/React.createElement("span", {
    className: cs(styles.title, _defineProperty({}, styles["title--with-subtitle"], subtitle))
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: title
  })), subtitle && /*#__PURE__*/React.createElement(I18n, {
    i18n: subtitle
  }));
}